import { Box, Flex, ListItem, UnorderedList } from '@chakra-ui/react';
import { useRouter } from 'next/router';
import React from 'react';
import Layout from '../components/Layout';
import { Roboto_Condensed } from 'next/font/google';
import Seo from '../components/Seo';
import Link from 'next/link';

// Subsets are really important.
const roboto = Roboto_Condensed({
  weight: '400', // if single weight, otherwise you use array like [400, 500, 700],
  style: 'normal', // if single style, otherwise you use array like ['normal', 'italic']
  subsets: ['latin'],
});

const CITIES = [
  'City Of London',
  'Chelsea',
  'Battersea',
  'Mayfair',
  'Westminister',
  'Victoria',
];

const AIRPORTS = [
  'London City Airport',
  'Southend Airport',
  'Gatwick Airport',
  'Stanstead Airport',
  'Heathrow Airport',
];

const LocationsPage = () => {
  let seo = {
    metaTitle: 'Our Locations',
    metaDescription: `Discover the extensive service coverage of Vert's all-electric chauffeur service. We serve numerous locations in London, Essex, and London's Aiports, ensuring you have access to luxury chauffeur service wherever you go. Explore our service areas and experience the pinnacle of travel comfort.`,
  };

  return (
    <Layout withAppNavBar={false}>
      <Seo seo={seo} />
      <Box>
        <Flex my={'170px'}>
          <Box className="container">
            <Box className="row align-center">
              <Box className="col-lg-6">
                <Box className="section-title">
                  <p>Locations</p>
                  <h2 className={roboto.className}>Cities</h2>
                </Box>
              </Box>
              <Box className="col-lg-6">
                <UnorderedList>
                  {CITIES.map((item, index) => {
                    return (
                      <ListItem
                        key={index}
                        listStyleType="none"
                        cursor={'pointer'}
                        m={2}
                      >
                        <Link href={`/?location=${item.replace(/\s+/g, '')}`}>
                          {item}
                        </Link>
                      </ListItem>
                    );
                  })}
                </UnorderedList>
              </Box>
            </Box>
          </Box>
        </Flex>

        <Flex my={'170px'}>
          <Box className="container">
            <Box className="row align-center">
              <Box className="col-lg-6">
                <Box className="section-title">
                  <p>Locations</p>
                  <h2 className={roboto.className}>Airports</h2>
                </Box>
              </Box>
              <Box className="col-lg-6">
                <UnorderedList>
                  {AIRPORTS.map((item, index) => {
                    return (
                      <ListItem
                        key={index}
                        listStyleType="none"
                        cursor={'pointer'}
                        m={2}
                      >
                        <Link href={`/?location=${item.replace(/\s+/g, '')}`}>
                          {item}
                        </Link>
                      </ListItem>
                    );
                  })}
                </UnorderedList>
              </Box>
            </Box>
          </Box>
        </Flex>
      </Box>
    </Layout>
  );
};

export default LocationsPage;
